import React, { useEffect, useMemo } from 'react';
import { Banner } from 'src/@vymo/ui/blocks';
import { getDetails } from 'src/models/details/selectors';
import {
  clearModuleButtons,
  setModuleButtons,
} from 'src/models/moduleButtons/slice';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { renderDialog } from 'src/workspace/slice';
// TODO: Move to modals
// eslint-disable-next-line vymo-ui/restrict-import
import { REVYRE_FORM } from '../constants';
import DetailsBody from './detailsBody';
import ProfileCard from './profileCard';
import {
  getModuleButtons,
  getReferredModuleActions,
  updateBreadcrumbs,
} from './queries';
import { getNotification, getPhoneCallDetails } from './selector';
import { clearPhoneDetails } from './slice';
import styles from './index.module.scss';

function Details360(props) {
  const { entityId } = props;
  const details = useAppSelector((state) => getDetails(state, entityId));
  const dispatch = useAppDispatch();

  const referredActions = useMemo(() => {
    const actions = getReferredModuleActions(details, props, dispatch);
    return actions;
  }, [details, dispatch, props]);

  const { activityId: callActivityId } = useAppSelector((state) =>
    getPhoneCallDetails(state),
  );

  const { message, messageId, variant } = useAppSelector(getNotification);

  useEffect(() => {
    const moduleButtons = getModuleButtons(referredActions);
    if (moduleButtons.length) {
      dispatch(setModuleButtons(moduleButtons));
    }

    return () => {
      dispatch(clearModuleButtons());
    };
  }, [details, dispatch, referredActions]);

  useEffect(() => {
    if (details?.inputsMap) {
      updateBreadcrumbs(dispatch, props, details?.inputsMap);
    }
  }, [details?.inputsMap, dispatch, props]);

  useEffect(() => {
    if (callActivityId && callActivityId === entityId) {
      dispatch(
        renderDialog({
          id: REVYRE_FORM,
          props: {
            domainType: 'activity',
            entityId: callActivityId,
            type: 'update',
            activityType: details?.inputsMap?.activityType,
            isPostCallForm: true,
          },
        }),
      );

      dispatch(clearPhoneDetails());
    }
  }, [callActivityId, dispatch, entityId, details?.inputsMap?.activityType]);

  return (
    <div className={styles.detailsWrapper}>
      {message && (
        <Banner
          key={messageId}
          message={message}
          variant={variant}
          position="topRight"
          duration={10000}
          closeable
        />
      )}
      <div className={styles.detailsWrapper__detailsGutter}>
        <ProfileCard {...props} />
        <DetailsBody {...props} />
      </div>
    </div>
  );
}

export default Details360;
